// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FaceOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48 12.5c-19.575 0-35.5 15.925-35.5 35.5S28.425 83.5 48 83.5 83.5 67.575 83.5 48 67.575 12.5 48 12.5m0 75C26.22 87.5 8.5 69.78 8.5 48S26.22 8.5 48 8.5 87.5 26.22 87.5 48 69.78 87.5 48 87.5ZM37.707 30.56c-1.69 0-3.062 2.096-3.062 4.678 0 2.585 1.372 4.678 3.062 4.678 1.69 0 3.062-2.093 3.062-4.678 0-2.582-1.372-4.677-3.062-4.677Zm20.549 0c-1.69 0-3.062 2.096-3.062 4.678 0 2.585 1.372 4.678 3.062 4.678 1.69 0 3.062-2.093 3.062-4.678 0-2.582-1.372-4.677-3.062-4.677ZM48 67.44c9.212 0 16.707-7.38 16.707-16.448a2 2 0 0 0-2-2H33.292a2 2 0 0 0-2 2c0 9.069 7.495 16.448 16.708 16.448ZM35.456 52.99h25.087c-.98 5.916-6.232 10.448-12.543 10.448-6.313 0-11.565-4.532-12.544-10.448Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default FaceOutline;
